import * as Yup from 'yup';
import { isValidNip } from '../../helpers/validation';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    employerType: Yup.string().required('Pole wymagane'),
    employerCompanyName: Yup.string().when('employerType', {
        is: 'abroad',
        then: Yup.string().required('Pole wymagane'),
    }),
    nip: Yup.string().when('employerType', {
        is: 'polish',
        then: Yup.string()
            .required('Pole wymagane')
            .test('nip', 'Nieprawidłowy NIP', (value) => isValidNip(value)),
    }),
    dateOfIllness: Yup.string().required('Pole wymagane').nullable(),
    dateOfBackToWork: Yup.string().required('Pole wymagane').nullable(),
    importantInformation: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
